/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'

export function useDebounce(params) {
  const { functionToDebounce, timer = 1500 } = params

  const [debounceRef, setDebounceRef] = useState(null)
  const [onChangeValue, setOnChangeValue] = useState(null)

  const onTriggerValueChange = (args) => {
    setOnChangeValue(args)
  }

  useEffect(() => {
    if (debounceRef) {
      clearTimeout(debounceRef)
      setDebounceRef(null)
    }
    const newTimer = setTimeout(() => {
      if (onChangeValue) {
        functionToDebounce && functionToDebounce(onChangeValue)
      }
    }, timer)

    setDebounceRef(newTimer)
  }, [onChangeValue])

  return {
    onTriggerValueChange,
  }
}
